export class NewMatchSettingsRequest {
    constructor(
        public readonly personalSettings: number[],
        public readonly sharedSettings: number[]
    ) { }
}
